module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAA8CAMAAADsSTwRAAAARVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAANDQ0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAODg4PkbNbAAAAFXRSTlMA3vYh5Dj7E/jw46vgw4BowmdYHwR5SawLAAAAn0lEQVRYw+3XOxLDMAhF0SBAH8u2/CP7X2q8ABTROE24LTOn0Kh5r+dKbStBr2x7sirrFKVXnFajs5NkAj3KQs3GLDFXRj2uOS42pghx98gkxcYEAeweESQ444wzzjjjjDPOOOOMM3/NDKfHT4dQG82yx0ai7hwV3npQD03RuxLPqjJzuqzIiYhdBhFPGwN3U+y8DNzZGBllY0r4nvb9PtlEHM9wHzw8AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reYiTi.png
// module id = Vwil
// module chunks = 2